import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';

const EMAIL_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

export const ConnectedEmailInput = React.forwardRef(
  ({ name, rules, required, id, ...props }, ref) => {

    return (
      <Controller
        name={name}
        rules={{
          required,
          pattern: {
            value: EMAIL_REGEX,
            message: 'Please enter a valid email address',
          },
          ...rules,
        }}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { invalid, error },
        }) => (
          <TextField
            id={id ?? name}
            variant='outlined'
            size='small'
            fullWidth
            {...props}
            name={name}
            value={value || ''}
            onChange={(e) => {
              const value = e.target.value;
              onChange(value);
            }}
            type='email'
            onBlur={onBlur}
            inputProps={props.inputProps}
            ref={ref}
            error={invalid}
            helperText={error?.message}
            required={Boolean(required || rules?.required)}
          />
        )}
      />
    );
  },
);

ConnectedEmailInput.displayName = 'ConnectedEmailInput';

ConnectedEmailInput.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
};
